import {schema} from "normalizr"

/**
 * Order lines schemas.
 */
export const checkbooks = new schema.Entity("checkbooks")
export const arrayOfCheckbooks = [checkbooks]
